export enum ShakaRobustness { 
    MANIFEST_RETRY_ATTEMPTS = 2,
    MANIFEST_RETRY_INTERVAL = 1000,
    // NOTE: Shaka's maxAttempts parameter includes the initial failed attempt, so if the desired goal is to perform 3 retrires, this should be set to 4
    FATAL_ERROR_RECOVERY_ATTEMPTS = 4, 
    FATAL_ERROR_RECOVERY_DELAY = 1000,
    FATAL_ERROR_RECOVERY_BACKOFF = 2,
    FATAL_ERROR_RECOVERY_FUZZ = 0
}